'use es6';

import { createSelector } from 'reselect';
import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getIndexedAsyncThreadDetails } from './getIndexedAsyncThreadDetails';
const getThreadIdFromProps = (__state, {
  threadId
}) => threadId;
export const getAsyncThreadDetails = createSelector([getThreadIdFromProps, getIndexedAsyncThreadDetails], (threadId, indexedAsyncThreadDetails) => threadId ? getEntry(threadId, indexedAsyncThreadDetails) : getNotSetValue(indexedAsyncThreadDetails));